import API from '@/utils/API'
import { BankNameInitialGroups } from '@/utils/MasterBank'
import { ActionContext } from 'vuex'

export const PICKER_SET_INDEX = {
  MAJOR_BANKS_AND_BANK_NAME_INITIAL_GROUPS: 0,
  BANK_NAME_INITIALS: 1,
  BANKS_SEARCH_BY_INITIAL: 2,
}

const state = {
  isActive: false,
  selectedBank: null as Bank | null,
  pickerSetIndex: 0,
  selectedBankNameInitialGroupName: null as string | null,
  banksSearchByInitial: [] as Bank[],
}

interface Bank {
  bank_code: string
  bank_name: string
}

type State = typeof state
type ModuleActionContext = ActionContext<State, {}>

const getters = {
  needsShowBackButton: (state: State) => {
    return state.pickerSetIndex > 0
  },
  bankNameInitials: (state: State) => {
    const initialGroup = BankNameInitialGroups.find(
      (group) => group.name === state.selectedBankNameInitialGroupName
    )
    if (!initialGroup) {
      return []
    }
    return initialGroup.initials
  },
  pickerSetTitle: (state: State) => {
    switch (state.pickerSetIndex) {
      case PICKER_SET_INDEX.MAJOR_BANKS_AND_BANK_NAME_INITIAL_GROUPS:
        return '銀行名'
      case PICKER_SET_INDEX.BANK_NAME_INITIALS:
      case PICKER_SET_INDEX.BANKS_SEARCH_BY_INITIAL:
        if (!state.selectedBankNameInitialGroupName) {
          return ''
        }
        return `50音順: ${state.selectedBankNameInitialGroupName}行`
      default:
        return null
    }
  },
}

const actions = {
  showBankPicker: function ({ commit }: ModuleActionContext) {
    commit('setIsActive', true)
    commit('resetPikcker')
  },
  closeBankPicker: function ({ commit }: ModuleActionContext) {
    commit('setIsActive', false)
  },
  selectBank: function ({ commit }: ModuleActionContext, bank: Bank) {
    commit('setSelectedBank', bank)
    commit('setIsActive', false)
  },
  selectBankNameInitialGroup: function (
    { commit }: ModuleActionContext,
    initialGroup: { name: string }
  ) {
    commit('setSelectedBankNameInitialGroupName', initialGroup.name)
    commit('setPickerSetIndex', PICKER_SET_INDEX.BANK_NAME_INITIALS)
  },
  selectBankNameInitial: function (
    { commit, dispatch }: ModuleActionContext,
    initial: { value: any }
  ) {
    commit('setBanksSearchByInitial', [])
    commit('setPickerSetIndex', PICKER_SET_INDEX.BANKS_SEARCH_BY_INITIAL)
    dispatch('searchBanksByInitials', initial)
  },
  searchBanksByInitials: async function (
    { commit }: ModuleActionContext,
    initial: { value: any }
  ) {
    const request = API.Request.masterBankSearchByBankNameInitials(
      initial.value
    )
    const response = await API.load(request)
    if (response.MasterBanks) {
      commit('setBanksSearchByInitial', response.MasterBanks)
    }
  },
  onClickBackButton: function ({ commit, state }: ModuleActionContext) {
    if (state.pickerSetIndex > 0) {
      commit('setPickerSetIndex', state.pickerSetIndex - 1)
    }
  },
}

const mutations = {
  setIsActive(state: State, isActive: boolean) {
    state.isActive = isActive
  },
  setSelectedBankNameInitialGroupName(state: State, name: string) {
    state.selectedBankNameInitialGroupName = name
  },
  setBanksSearchByInitial(state: State, banks: Bank[]) {
    state.banksSearchByInitial = banks
  },
  setPickerSetIndex(state: State, pickerSetIndex: number) {
    state.pickerSetIndex = pickerSetIndex
  },
  setSelectedBank(state: State, bank: Bank) {
    state.selectedBank = bank
  },
  resetPikcker(state: State) {
    state.selectedBank = null
    state.pickerSetIndex =
      PICKER_SET_INDEX.MAJOR_BANKS_AND_BANK_NAME_INITIAL_GROUPS
    state.selectedBankNameInitialGroupName = null
    state.banksSearchByInitial = []
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
